// extracted by mini-css-extract-plugin
module.exports = {"document":"discounts_document__3PgzP","info":"discounts_info__goJvT","infoRow":"discounts_infoRow__2d-MG","submitContainer":"discounts_submitContainer__1zR43"};